import axios from "../../../config/axiosConfig";

export const obtenerCoordinaciones = async (sucursal = "La Paz") => {
  const qsSucursal = encodeURIComponent(sucursal); // ← importante para "Santa Cruz"
  const { data } = await axios.get(
    `/api/req-solicitudes/coordinaciones/ultimos30?sucursal=${qsSucursal}`
  );
  return data;
};
